import type { CancelToken } from 'axios';
import requestClient from '../utilities/requestClient';

/**
 * Same-origin HG (legacy Bottle / HTML app) HTTP used alongside the public API auth service.
 * Uses {@link requestClient} / BASE_URL — not {@link ./risksystem3-public-api}.
 */

export type ApiSessionResponse = {
  login_return_code: number;
  client_name?: string;
};

/** POST `/api_session` — HG session cookie from verified public JWT. */
const bootstrapApiSession = (accessToken: string) =>
  requestClient().post<ApiSessionResponse>('/api_session', null, {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });

/** GET `/logout` */
const logout = () => requestClient().get('/logout');

/** GET published Raptor client config JSON (e.g. `en/{config_name}.json`). */
const getRaptorConfig = (configUrl: string, cancelToken: CancelToken) =>
  requestClient().get(configUrl, { cancelToken });

/** POST `/api/v1/require_qr_code` */
const requireQrCode = (authKey: string, accessToken: string) =>
  requestClient().post(
    '/api/v1/require_qr_code',
    { auth_key: authKey },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );

const RisksystemHgAuthService = {
  bootstrapApiSession,
  logout,
  getRaptorConfig,
  requireQrCode,
};

export default RisksystemHgAuthService;
